($ => {

    $('.js-Tip-close').click(function(ev) {
        $(this).closest('.Tip').slideUp()
    })

})(jQuery)